<template>
    <div
        class="competence-wrapper"
    >
        <router-link
            class="title"
            :to="{ name: 'competence', params: { id: competence.id } }"
        >{{competence.name}}</router-link>
        <div class="competence-content">
            <div
                class="competence"
                :style="{ height: itemHeight }"
            >
                <div class="required-level"></div>
                <div
                    class="currentLevel"
                    :class="{ default: defaultState, complete: completeState}"
                    :style="{ bottom:  levelPosition }"
                ></div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const trackGetters = [
    'getCompetenceLevels',
];
export default {
    name: 'SoftCompetenceItem',
    props: {
        competence: Object,
    },
    computed: {
        ...mapGetters('accountTrack', trackGetters),
        itemHeight() {
            return 48 * this.numberEnd(this.competence.requiredLevel) + 'px';
        },
        levelPosition() {
            return 48 * (
                Math.min(
                    this.numberEnd(this.competence.competenceLevel),
                    this.numberEnd(this.competence.requiredLevel),
                ) - 1) + 'px';
        },
        defaultState() {
            return this.numberEnd(this.competence.competenceLevel) === 1;
        },
        completeState() {
            return Math.min(
                this.numberEnd(this.competence.competenceLevel),
                this.numberEnd(this.competence.requiredLevel),
            ) === this.numberEnd(this.competence.requiredLevel);
        },
    },
    methods: {
        numberEnd(level) {
            return this.getCompetenceLevels.length -
                this.getCompetenceLevels.findIndex(v => v.key === level);
        },
    },
};
</script>

<style lang="scss" scoped>
.competence-wrapper{
    width: 48px;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: center;

    .title{
        width: 129px;
        position: absolute;
        top: -77px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #4663AB;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        height: 65px;
    }
    .competence-content{
        width: 48px;
        background: #F5F9FC;
        border: 1px solid #E6E9EE;
        box-sizing: border-box;
        border-radius: 24px;
        .competence{
            width: 48px;
            position: relative;
            .currentLevel{
                width: 48px;
                height: 48px;
                border: 2px solid #8D7BFB;
                box-sizing: border-box;
                border-radius: 36px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                position: absolute;
                bottom:0;
                left:-1px;
                background-image: url("../../../../../../assets/images/account-track/icon/competences/competence.svg");
                background-repeat: no-repeat;
                background-position: center center;
            }
            .default{
                border: 2px solid #D2D5D9;
                background-image: url("../../../../../../assets/images/account-track/icon/competences/competence-default.svg");
            }
            .complete{
                border: 2px solid #8D7BFB;
                background-image: url("../../../../../../assets/images/account-track/icon/competences/competence-complete.svg");
            }
            .required-level{
                width: 48px;
                height: 48px;
                background-image: url("../../../../../../assets/images/account-track/icon/competences/flag.svg");
                background-repeat: no-repeat;
                background-position: center center;
                margin-left: -1px;
            }
        }
    }

}
</style>